import React from 'react';
import {
  Badge,
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';

const TransactionDetailModal = ({
  isOpen,
  onClose,
  detailTitle,
  detailLoading,
  detailTransactions,
  selectedMember,
  formatCurrency,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>{detailTitle}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        {detailLoading ? (
          <Box textAlign="center" py={8}>
            <Spinner size="lg" />
          </Box>
        ) : detailTransactions.length > 0 ? (
          <TableContainer maxH="500px" overflowY="auto">
            <Table size="sm" variant="simple">
              <Thead position="sticky" top={0} bg="gray.50" zIndex={1}>
                <Tr>
                  <Th>Transaction Date</Th>
                  <Th>Transaction Number</Th>
                  {selectedMember === 'RETAIL' ? (
                    <>
                      <Th>Customer</Th>
                      <Th>Location</Th>
                    </>
                  ) : (
                    <>
                      <Th>Branch</Th>
                      <Th>Cashier</Th>
                    </>
                  )}
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {detailTransactions.map((transaction, index) => (
                  <Tr key={index} _hover={{ bg: 'gray.50' }}>
                    <Td fontSize="sm">
                      {selectedMember === 'RETAIL' ? transaction.date_order : transaction.PRODUCTSERVICES_TRANSACTIONDATE}
                    </Td>
                    <Td fontSize="sm" fontWeight="semibold">
                      {selectedMember === 'RETAIL' ? transaction.order_number : transaction.PRODUCTSERVICES_TRANSACTIONNUMBER}
                    </Td>
                    {selectedMember === 'RETAIL' ? (
                      <>
                        <Td fontSize="sm">
                          {transaction.customer_name && transaction.customer_name !== '-' ? transaction.customer_name : transaction.referral_code2 || '-'}
                        </Td>
                        <Td fontSize="sm">{transaction.location || '-'}</Td>
                      </>
                    ) : (
                      <>
                        <Td fontSize="sm">{transaction.PRODUCTSERVICES_BRANCHCODE || '-'}</Td>
                        <Td fontSize="sm">{transaction.PRODUCTSERVICES_CASHIERNAME || '-'}</Td>
                      </>
                    )}
                    <Td isNumeric fontSize="sm" fontWeight="semibold" color="green.600">
                      {formatCurrency(
                        selectedMember === 'RETAIL' ? transaction.total || 0 : parseFloat(transaction.PRODUCTSERVICES_SUBTOTAL || 0)
                      )}
                    </Td>
                    <Td>
                      <Badge colorScheme="green" fontSize="xs">
                        Completed
                      </Badge>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Text color="gray.500" textAlign="center" py={8}>
            No transactions found
          </Text>
        )}
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="blue" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default TransactionDetailModal;
